function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import 'scss/footer.scss';
import { Link } from 'react-router-dom';
import { DownloadButton, PremiumButton } from 'js/components/molecules/Button';
import { logout } from 'js/store/actions/auth';
import Feedback from '../../molecules/Button/FeedBack';
import LocalizationDropdown from '../../../containers/legacy/LocalizationDropdown';
import ShoppingCart from '../../../containers/organisms/Panel/ShoppingCart';
import { Container, Left, Right, Button, ButtonContainer } from './style';

var Header =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _this.listenScrollEvent = function () {
      if (window.scrollY > 400) {
        _this.props.actions.setBackground('white');

        _this.props.actions.setColor('gray');
      } else {
        _this.props.actions.setBackground('transparent');

        _this.props.actions.setColor('white');
      }
    };

    _this.handleLogout = function () {
      logout();
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "togglePanel",
    value: function togglePanel() {
      var state = this.state;
      state.active = !state.active;
      this.setState(state);
      return state;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.listenScrollEvent, true);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.listenScrollEvent, true);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          userRole = _this$props.userRole,
          shoppingCart = _this$props.shoppingCart,
          history = _this$props.history,
          active = _this$props.active;
      var color = this.props.nav.color;
      var background = this.props.nav.background;
      var homePage = history.location.pathname == '/search';
      var dashboard = history.location.pathname.startsWith('/countries');
      var shoppingCartItems = shoppingCart && shoppingCart.plots ? Object.keys(shoppingCart.plots).length : 0;
      return React.createElement(Container, {
        background: background || 'transparent'
      }, ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'].includes(userRole) ? React.createElement(Link, {
        to: '/search'
      }, React.createElement(Left, {
        color: color || 'gray'
      }, "COSMOS")) : React.createElement(Left, {
        color: color || 'gray'
      }, "COSMOS"), React.createElement(Right, null, ['freeTrialCustomer', 'normalCustomer', 'premiumCustomer'].includes(userRole) ? React.createElement(ButtonContainer, null, React.createElement(Button, {
        color: color || 'white',
        onClick: function onClick() {
          return _this2.handleLogout();
        }
      }, "Logout")) : '', React.createElement(Feedback, {
        dark: color === 'gray',
        color: color || 'white'
      }), React.createElement(LocalizationDropdown, {
        dark: color === 'gray',
        color: color || 'white'
      }), ['freeTrialCustomer', 'normalCustomer'].includes(userRole) && dashboard ? React.createElement("div", null, React.createElement(DownloadButton, {
        color: color || 'white',
        counter: shoppingCartItems,
        handleClick: function handleClick() {
          return _this2.togglePanel();
        },
        active: this.state.active
      }), React.createElement(ShoppingCart, {
        institution_type: this.props.institution_type,
        users_country: this.props.users_country,
        togglePanel: function togglePanel() {
          return _this2.togglePanel();
        },
        active: this.state.active
      })) : '', ['freeTrialCustomer', 'normalCustomer'].includes(userRole) && homePage && active ? React.createElement(PremiumButton, {
        handleClick: function handleClick() {
          return history.push('/choose-plan');
        },
        className: "premium-btn btn-primary"
      }, "COSMOS Premium") : ''));
    }
  }]);

  return Header;
}(React.Component);

export { Header as default };
Header.propTypes = {
  showShoppingCart: PropTypes.bool,
  shoppingCart: PropTypes.object,
  active: PropTypes.bool,
  actions: PropTypes.object,
  users_country: PropTypes.string,
  institution_type: PropTypes.string,
  history: PropTypes.object,
  nav: PropTypes.object,
  userRole: PropTypes.string
};